export const BUS_TAX = 20;
export const TRAIN_TAX = 30;
export const FLIGHT_TAX = 40;
